module.exports = __webpack_public_path__ + "static/media/do.5b1f6622.svg";